export const addResponseToPoll = `
  mutation addResponseToPoll(
    $pk: String!,
    $sk: String!,
    $GSI2PK: String!,
    $GSI2SK: String!,
    $response: ResponseDetailsInput!) {
      addResponseToPoll(
        pk: $pk,
        sk: $sk,
        GSI2PK: $GSI2PK,
        GSI2SK: $GSI2SK,
        response: $response
      ) {
        pk
        sk
        GSI2PK
        GSI2SK
        response {
          choiceIndexes
          portalQid
          responseType
          text
          shortAnswerBlanks {
            blankUID
            userAnswer
          }
          userId
        }
      }
  }
`;

export const deletePollResponse = `
  mutation deletePollResponse($response: DeletePollResponseInput!) {
    deletePollResponse( input: $response ) {
      pk
      sk
      GSI2PK
      GSI2SK
    }
  }
`;

export const updatePollInput = `
  mutation updatePollInput($pk: ID!, $sk: String, $LSI1SK: String, $currentQuestion: String, $lastInstructor: String) {
    updatePollInput( input: {
      pk: $pk
      sk: $sk
      LSI1SK: $LSI1SK,
      currentQuestion: $currentQuestion
      lastInstructor: $lastInstructor
    }) {
      pk
      sk
      LSI1SK
      currentQuestion
      lastInstructor
    }
  }
`;

export const updatePoll = `
  mutation updatePoll($pollId: ID!, $currentQuestion: String, $status: String, $esId: String) {
    updatePoll( input: {
      pk: $pollId
      currentQuestion: $currentQuestion
      LSI1SK: $status,
      lastInstructor: $esId
    }) {
      pk
      currentQuestion
      LSI1SK
      lastAccessed
      lastInstructor
    }
  }
`;

export const completeUserPoll = `
  mutation completeUserPoll($esId: String!, $pollId: String!) {
    completeUserPoll(
      pk: $esId,
      sk: $pollId
    ){
      pk
      sk
      LSI1SK
    }
  }
`;

export const updateLastAccessed = `
  mutation updateLastAccessed($pk: ID!, $sk: String) {
    updateLastAccessed( input: {
      pk: $pk
      sk: $sk
    }){
      pk
      sk
      lastAccessed
    }
  }
`;

export const updateQuestionStatus = `
  mutation updateQuestionStatus($pollId: String!, $questionId: String!, $questionStatus: String!) {
    updateQuestionStatus(pk: $pollId, sk: $questionId, questionStatus: $questionStatus) {
      pk
      sk
      questionStatus
    }
  }
`;

export const activatePoll = `
  mutation activatePoll($pollId: String!) {
      activatePoll(
          pk: $pollId
      ) {
          pk
          LSI1SK
      }
  }
`;

export const activateUserPoll = `
  mutation activateUserPoll($userId: String!, $pollId: String!) {
      activateUserPoll(
          pk: $userId
          sk: $pollId
      ) {
          pk
          sk
          LSI1SK
      }
  }
`;
